const FLAG_SELECT_IDS = new Set(['nationality', 'destination']);

export function stripLeadingFlagChars(text) {
    if (text === null || text === undefined) {
        return '';
    }
    let s = String(text).trim();
    s = s.replace(/^(\uD83C[\uDDE6-\uDDFF]\uD83C[\uDDE6-\uDDFF]\s*)+/, '');
    try {
        s = s.replace(/^(\p{Extended_Pictographic}+[\s\uFE0F]*)+/u, '');
    } catch (e) {
        // Older JS engines without Unicode property escapes
    }
    return s.trim();
}

export function formatCountryOption(option) {
    if (!option.id) {
        return option.text;
    }

    let countryCode = '';
    if (option.element) {
        countryCode = $(option.element).data('country-code') || '';
    }

    const label = stripLeadingFlagChars(option.text);
    if (countryCode) {
        const flagClass = 'iti__flag iti__' + String(countryCode).toLowerCase();
        const $result = $('<span></span>');
        $result.append($('<span class="nationality-flag-icon ' + flagClass + '"></span>'));
        $result.append(document.createTextNode(' ' + label));
        return $result;
    }

    return label;
}

export function formatCountrySelect2Option(option) {
    return formatCountryOption(option);
}

export function countrySelect2UsesFlags(selectId) {
    return FLAG_SELECT_IDS.has(selectId);
}

export function getCountryFieldOptions($el) {
    const options = {
        templateResult: formatCountryOption,
        templateSelection: formatCountryOption,
    };

    const noResultsText = $el.data('no-results') || null;
    if (noResultsText) {
        options.language = {
            noResults: function() {
                return noResultsText;
            },
        };
    }

    return options;
}

export function applyCountrySelect2Templates(options = {}) {
    const template = options.template || formatCountryOption;
    const $root = options.$root ? $(options.$root) : $(document);

    $root.find('select.select2, select[data-country-select]').each(function () {
        const $el = $(this);
        const id = $el.attr('id');
        if (!countrySelect2UsesFlags(id) && !$el.is('[data-country-select]')) {
            return;
        }

        const select2Options = {
            templateResult: template,
            templateSelection: template,
        };

        const noResultsText = $el.data('no-results') || null;
        if (noResultsText) {
            select2Options.language = {
                noResults: () => noResultsText,
            };
        }

        if ($el.data('select2')) {
            $el.select2('destroy');
        }

        $el.select2(select2Options);
    });
}

export function applyCountryFlagTemplates(context) {
    applyCountrySelect2Templates({ $root: context });
}

if (typeof window !== 'undefined') {
    window.applyCountryFlagTemplates = applyCountryFlagTemplates;
}
